export class XrtSortExpressions {
  constructor(
    public Column: string,
    public IsDecendingSort: boolean,
  ) { }
}
